module.exports = __webpack_public_path__ + "static/sd-pro-premier-academy-139x150-e5bfdcf94fb09d2ad38b4ddc743d2056.png";